var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_7653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.33333H11.3333V2.66667H1.99996C1.26663 2.66667 0.666626 3.26667 0.666626 4V11.3333H1.99996C1.99996 12.44 2.89329 13.3333 3.99996 13.3333C5.10663 13.3333 5.99996 12.44 5.99996 11.3333H9.99996C9.99996 12.44 10.8933 13.3333 12 13.3333C13.1066 13.3333 14 12.44 14 11.3333H15.3333V8L13.3333 5.33333ZM13 6.33333L14.3066 8H11.3333V6.33333H13ZM3.99996 12C3.63329 12 3.33329 11.7 3.33329 11.3333C3.33329 10.9667 3.63329 10.6667 3.99996 10.6667C4.36663 10.6667 4.66663 10.9667 4.66663 11.3333C4.66663 11.7 4.36663 12 3.99996 12ZM5.47996 10C5.11329 9.59333 4.59329 9.33333 3.99996 9.33333C3.40663 9.33333 2.88663 9.59333 2.51996 10H1.99996V4H9.99996V10H5.47996ZM12 12C11.6333 12 11.3333 11.7 11.3333 11.3333C11.3333 10.9667 11.6333 10.6667 12 10.6667C12.3666 10.6667 12.6666 10.9667 12.6666 11.3333C12.6666 11.7 12.3666 12 12 12Z",
    fill: "#2C20DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_7653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingIcon);
export default __webpack_public_path__ + "static/media/ShippingIcon.22bd985e0ffd8ef465fd3c1b46eda13c.svg";
export { ForwardRef as ReactComponent };